import React from 'react';
import { GDFDiversionRecord } from '../../gdf/type';

export function DiversionProperties({ record }: { record: GDFDiversionRecord }) {
    const from = React.useMemo(() => record.elements.filter((x) => x.type === 'F'), [record]);
    const to = React.useMemo(() => record.elements.filter((x) => x.type === 'T'), [record]);

    return (
        <div style={{ minWidth: 350 }}>
            <div>
                Diversion from ({from.length} - {trends[record.fromTrend] ?? 'unchanged'})
            </div>
            <table className="cobalt-table cobalt-alternate w-100">
                <thead>
                    <tr>
                        <th className="ps-2">ACID</th>
                        <th>New destination</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {from.map((x, i) => (
                        <tr key={i}>
                            <td className="ps-2">{x.acid}</td>
                            <td>{x.airportToFrom}</td>
                            <td>{x.active ? 'Active' : 'Landed'}</td>
                        </tr>
                    ))}
                    {!from.length && (
                        <tr>
                            <td className="ps-2 secondary-text text-center" colSpan={99}>
                                No items.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            <div className="pt-2">
                Diversion to ({to.length} - {trends[record.toTrend] ?? 'unchanged'})
            </div>
            <table className="cobalt-table cobalt-alternate w-100">
                <thead>
                    <tr>
                        <th className="ps-2">ACID</th>
                        <th>Previous destination</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {to.map((x, i) => (
                        <tr key={i}>
                            <td className="ps-2">{x.acid}</td>
                            <td>{x.airportToFrom}</td>
                            <td>{x.active ? 'Active' : 'Landed'}</td>
                        </tr>
                    ))}
                    {!to.length && (
                        <tr>
                            <td className="ps-2 secondary-text text-center" colSpan={99}>
                                No items.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
}

const trends: Partial<Record<GDFDiversionRecord['toTrend'], string>> = {
    I: 'increasing',
    D: 'decreasing'
};
